import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store'

// easy way to bypass ts issue, todo will be improved https://app.shortcut.com/systeme/story/28840/use-redux-toolkit-for-store-managing
export const useAppDispatch = useDispatch.withTypes<any>()

export const useAppSelector = useSelector.withTypes<RootState>()
